/* tslint:disable */

/**
 * HR Portal API
 * HR Portal API
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * An enumeration.
 * @export
 * @enum {string}
 */
export enum Consent {
    CodeOfConduct = 'Code of conduct',
    FieldServicesSiteAccessConsent = 'Field Services site access consent',
    SingaporeCrossBorderPshConsent = 'Singapore cross border PSH consent',
    MalaysiaCrossBorderPshConsent = 'Malaysia cross border PSH consent',
    NdasRelatedToWorkRelationship = 'NDA\'s related to work relationship',
    CdpAuthorizationForm = 'CDP Authorization Form'
}

export function ConsentFromJSON(json: any): Consent {
    return ConsentFromJSONTyped(json, false);
}

export function ConsentFromJSONTyped(json: any, _: boolean): Consent {
    return json as Consent;
}

export function ConsentToJSON(value?: Consent | null): any {
    return value as any;
}
